import { useContact } from 'ducks/crm/contacts/hooks'
import { capitalize } from 'util/strings'

export default function ContactName({ contactId }) {
  const { contact, isLoaded } = useContact(contactId)
  if (!isLoaded) return <>Loading...</>

  return <>{capitalize(contact.name)}</>
}
